/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const dependencies = [
  '$q', 'Client', 'selectService', 'Employee', 'ClientService', 'ClientEmployeeResource', 'Role',
  'EmployeeResource', 'EmployeeBan', 'BulkRateService', 'resourceChargeType', 'employeeStatus',
  'activeStatus', 'clientStatus', 'rateType'
];

const SecurityManagerHrBulkRateController = function(
  $q, Client, selectService, Employee, ClientService, ClientEmployeeResource, Role,
  EmployeeResource, EmployeeBan, BulkRateService, resourceChargeType, employeeStatus,
  activeStatus, clientStatus, rateType
) {

  const vm = this;

  vm.selectedClient = {};
  vm.hoveredEmployeeRowId = null;
  vm.resourcesRates = {};
  vm.isMenuDropdownOpened = false;
  vm.openedMenuDropdownCell = {};
  vm.searchEmployee = '';
  vm.checkedEmployees = [];
  vm.editable = true;
  vm.selectedRoles = [];
  vm.rateType = rateType;
  vm.selectedRateType = rateType.getPayRate();

  let clientRoles = [];
  let resourceRoles = {};

  const bulkRateService = new BulkRateService(function() {
    vm.approvedEmployees = bulkRateService.getApprovedEmployees();
    vm.unapprovedEmployees = bulkRateService.getUnapprovedEmployees();
    vm.employeeResources = bulkRateService.getEmployeeResources();
  });

  vm.$onInit = function() {
    loadClients();
    loadEmployees();
  };

  vm.onClientSelect = function(client) {
    vm.selectedClient.clientId = client.id;
    vm.rolesForSelect = [];
    vm.employeeResources = {};
    return $q.all([
      loadClientEmployeeResources(client.id),
      loadClientServices(client.id),
      loadClientEmployeeBans(client.id),
      loadClientRoles(client.id),
      loadApprovedEmployees(client.id)
    ]).then(result => setResources(result));
  };

  vm.toggleMenuDropdown = function(employeeId, resourceId) {
    if (vm.openedMenuDropdownCell.employeeId) {
      vm.closeMenuDropdown();
    } else {
      vm.openedMenuDropdownCell.employeeId = employeeId;
      vm.openedMenuDropdownCell.resourceId = resourceId;
    }
  };

  vm.closeMenuDropdown = function() {
    vm.openedMenuDropdownCell.employeeId = null;
    vm.openedMenuDropdownCell.resourceId = null;
  };

  vm.isActiveCell = employeeResource => {
    return (employeeResource.employeeId === vm.openedMenuDropdownCell.employeeId) &&
      (employeeResource.resourceId === vm.openedMenuDropdownCell.resourceId);
  };

  vm.banEmployee = employeeId => bulkRateService.banEmployee(vm.selectedClient.clientId, employeeId);

  vm.unbanEmployee = employeeId => bulkRateService.unbanEmployee(vm.selectedClient.clientId, employeeId);

  vm.onCheckEmployee = function(employee) {
    const foundEmployee = vm.checkedEmployees.indexOf(employee.employeeId);
    if (foundEmployee === -1) {
      vm.checkedEmployees.push(employee.employeeId);
    } else {
      vm.checkedEmployees.splice(foundEmployee, 1);
    }
  };

  vm.isCheckedEmployee = employeeId => isPresent(vm.checkedEmployees, employeeId);

  vm.needCap = function(index) {
    let approvedEmployees;
    if (vm.searchEmployee) {
      approvedEmployees = _.filter(vm.approvedEmployees, compareFullName);
    } else {
      ({ approvedEmployees } = vm);
    }
    return index === approvedEmployees.length;
  };

  vm.isShownUnapprovedEmployees = function() {
    let unapprovedEmployees;
    if (!vm.unapprovedEmployees) { return false; }
    if (vm.searchEmployee) {
      unapprovedEmployees = _.filter(vm.unapprovedEmployees, compareFullName);
    } else {
      ({ unapprovedEmployees } = vm);
    }
    return unapprovedEmployees.length > 0;
  };

  vm.onApprove = function(approvedEmployeeResource) {
    if (vm.checkedEmployees.length && isPresent(vm.checkedEmployees, approvedEmployeeResource.employeeId)) {
      applyMultiSetRate(approvedEmployeeResource, true);
    } else {
      approvedEmployeeResource.save();
      bulkRateService.applySingleSetRate(approvedEmployeeResource.employeeId);
    }
    vm.uncheckEmployees();
  };

  vm.onRateChange = function(employeeResource, rateChange) {
    if (vm.checkedEmployees.length && isPresent(vm.checkedEmployees, employeeResource.employeeId)) {
      bulkRateService.applyMultiPayRateChange(
        employeeResource,
        rateChange,
        vm.checkedEmployees,
        vm.uncheckEmployees
      );
    }
  };

  vm.onSetRate = function(changedEmployeeResource) {
    if (vm.checkedEmployees.length && isPresent(vm.checkedEmployees, changedEmployeeResource.employeeId)) {
      applyMultiSetRate(changedEmployeeResource);
    } else {
      changedEmployeeResource.save();
      bulkRateService.applySingleSetRate(changedEmployeeResource.employeeId);
    }
    vm.uncheckEmployees();
  };

  vm.onUnapprove = function(unapprovedEmployeeResource) {
    if (vm.checkedEmployees.length && isPresent(vm.checkedEmployees, unapprovedEmployeeResource.employeeId)) {
      applyMultiUnapprove(unapprovedEmployeeResource);
    } else {
      unapprovedEmployeeResource.remove().then(function() {
        unapprovedEmployeeResource.payRate = null;
        bulkRateService.applySingleUnapprove(unapprovedEmployeeResource.employeeId);
      });
    }
    vm.uncheckEmployees();
  };

  vm.onRoleSelect = function(role) {
    if (role.id) {
      vm.selectedRoles = [role];
    } else {
      vm.selectedRoles = clientRoles;
    }
  };

  vm.getEmployeeResources = function(resource) {
    return _.filter(vm.employeeResources[resource.id], function(employeeResource) {
      const employee = employeeResource.employee;
      return employee.fullName.search(new RegExp(vm.searchEmployee, 'i')) !== -1 && (
        vm.selectedRoles.length === 0 ||
        vm.selectedRoles[0] instanceof Role ||
        _.intersectionBy(employee.roles, vm.selectedRoles, 'id').length > 0
      );
    });
  };

  vm.uncheckEmployees = function() {
    vm.checkedEmployees = [];
    vm.employees.forEach(employee => employee.isChecked = false);
  };

  const applyMultiSetRate = function(changedEmployeeResource, isApprove = false) {
    bulkRateService.applyMultiSetRate(
      changedEmployeeResource,
      isApprove,
      vm.checkedEmployees,
      vm.uncheckEmployees,
      rateType.getField(vm.selectedRateType)
    );
  };

  const applyMultiUnapprove = unapprovedEmployeeResource => {
    return bulkRateService.applyMultiUnapprove(
      unapprovedEmployeeResource.resourceId,
      vm.checkedEmployees
    );
  };

  const loadClients = () => {
    Client.autocomplete({ 'order[name]': 'asc', status: clientStatus.getActiveStatus() }).then(function (clients) {
      vm.clients = selectService.toSelectArray(clients, { defaultField: 'All' });
      vm.clientsForSelected = formSelected(vm.clients, 'Choose client');
    });
  };

  const loadEmployees = () => {
    return Employee.query({
      'order[full_name]': 'asc',
      template: 'bulk_pay_rate',
      status: employeeStatus.getActiveStatus()
    }).then(function (employees) {
      employees.forEach(employee => employee.lowerCaseFullName = employee.fullName.toLowerCase());
      vm.employees = _.orderBy(employees, ['lowerCaseFullName']);
      return bulkRateService.setEmployees(vm.employees);
    });
  };

  const loadClientServices = function(clientId) {
    vm.clientServices = [];
    return ClientService.query({ activeStatus: activeStatus.getActiveStatus() }, { clientId }).then(services =>
      services.forEach(function(service) {
        const filteredResources = service.resources.filter(resource => {
          return !resourceChargeType.isPerUnit(resource.chargeType) && activeStatus.isActive(resource.activeStatus);
        });
        if (filteredResources.length) {
          service.resources = filteredResources;
          return vm.clientServices.push(service);
        }
      })
    );
  };

  const loadClientEmployeeBans = clientId => {
    return EmployeeBan.query({}, { clientId }).then(function (bannedEmployees) {
      vm.bannedEmployees = _.map(bannedEmployees, 'employeeId');
      return vm.employees.forEach(employee => employee.isBanned = isPresent(vm.bannedEmployees, employee.employeeId));
    });
  };

  const loadApprovedEmployees = clientId => {
    return Employee.getWithResources({ clientId }).then(function (employeeWithResources) {
      vm.approvedEmployees = [];
      vm.unapprovedEmployees = [];
      vm.approvedEmpoyeesIds = _.map(employeeWithResources.approvedEmployees, 'employeeId');
      vm.employees.forEach(function (employee) {
        employee.hasApprovedResource = isPresent(vm.approvedEmpoyeesIds, employee.employeeId);
        if (employee.hasApprovedResource) {
          return vm.approvedEmployees.push(employee);
        } else {
          return vm.unapprovedEmployees.push(employee);
        }
      });
      bulkRateService.setApprovedEmployees(vm.approvedEmployees);
      return bulkRateService.setUnapprovedEmployees(vm.unapprovedEmployees);
    });
  };

  const loadClientRoles = function(clientId) {
    return Role.query({ clientId }).then(function(roles) {
      clientRoles = roles;
      vm.selectedRoles = clientRoles;
      vm.rolesForSelect = selectService.toSelectArray(roles, { defaultField: 'All' });
      vm.rolesForSelected = formSelected(vm.rolesForSelect, 'Choose role');
    });
  };

  const getApprovedEmployee = function(employeeResources, resourceId, employee) {
    let approvedEmployee = null;
    if (employeeResources.length) {
      employeeResources.forEach(function(resource) {
        if (resource.employeeId === employee.employeeId && resource.resourceId === resourceId) {
          return approvedEmployee = resource;
        }
      });
    }
    return approvedEmployee;
  };

  const loadClientEmployeeResources = clientId => ClientEmployeeResource.query({}, { clientId });

  const setResources = function(result) {
    const [employeeResources] = Array.from(result);
    const resourcesIds = [];
    vm.clientServices.forEach(service =>
      service.resources.forEach(function(resource) {
        resourcesIds.push(resource.id);
        vm.resourcesRates[resource.id] = {
          contractorPayRate: resource.contractorPayRate,
          employedPayRate: resource.employedPayRate,
          chargeRate: resource.chargeRate
        };
        resourceRoles[resource.id] = resource.roles;
      })
    );
    return buildResourcesTable(resourcesIds, employeeResources);
  };

  const buildResourcesTable = (resourcesIds, employeeResources) => {
    return resourcesIds.forEach(function (resourceId) {
      vm.employeeResources[resourceId] = [];
      vm.employees.forEach(function (employee) {
        const approvedEmployee = getApprovedEmployee(employeeResources, resourceId, employee);
        return buildResourcesArray(approvedEmployee, resourceId, employee);
      });
      return bulkRateService.setEmployeeResources(vm.employeeResources);
    });
  };

  const buildResourcesArray = function(approvedEmployee, resourceId, employee) {
    let id, payRate, chargeRate, overtimeRate, overtimeMinHours, rateChange, employeeFullName;
    if (approvedEmployee) {
      ({ id, payRate, chargeRate, overtimeRate, overtimeMinHours, rateChange } = approvedEmployee);
      employeeFullName = approvedEmployee.employee.fullName;
    } else {
      id = null;
      payRate = null;
      chargeRate = null;
      overtimeRate = null;
      overtimeMinHours = null;
      rateChange = null;
      employeeFullName = employee.fullName;
    }
    return vm.employeeResources[resourceId].push(new EmployeeResource({
      id, payRate, chargeRate, overtimeRate, overtimeMinHours, rateChange, resourceId,
      employeeId: employee.employeeId,
      isBanned: isPresent(vm.bannedEmployees, employee.employeeId),
      hasApprovedResource: employee.hasApprovedResource,
      resourceRoles: resourceRoles[resourceId],
      employee: {
        fullName: employeeFullName,
        roles: employee.roles,
        employmentType: employee.employmentType
      }
    }));
  };

  const formSelected = function(collection, defaultText) {
    const selectedCollection = _.cloneDeep(collection);
    selectedCollection[0].text = defaultText;
    return selectedCollection;
  };

  const isPresent = (collection, element) => {
    return collection.indexOf(element) !== -1;
  };

  const compareFullName = employee => {
    return employee.fullName.toLowerCase().indexOf(vm.searchEmployee.toLowerCase()) !== -1;
  };

  return vm;

};

angular.module('public.security-manager.hr')
  .controller('SecurityManagerHrBulkRateController', dependencies.concat(SecurityManagerHrBulkRateController));
